import React from 'react';

const NotFound = () => {
    return (
        <div>404 გვერდი ვერ მოიძებნა</div>
    );
}

export default NotFound;